import { u as scrollAnimationsDisabled } from "@theme/utils";
import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/page-header-animation.js
var SPACING = ">-0.8";
var PageHeaderAnimation = class extends window.HTMLElement {
	async connectedCallback() {
		if (scrollAnimationsDisabled()) return;
		await document.fonts.ready;
		this.eyebrow = this.querySelector(".page-header__eyebrow");
		this.headline = this.querySelector(".page-header__headline");
		this.subheadline = this.querySelector(".page-header__subheadline");
		this.button = this.querySelector(".page-header__button");
		const els = [
			this.eyebrow,
			this.headline,
			this.subheadline,
			this.button
		].filter(Boolean);
		gsapWithCSS.set(els, {
			opacity: 0,
			y: 10,
			visibility: "visible"
		});
		this.tl = gsapWithCSS.timeline({ defaults: {
			ease: "power3.out",
			duration: 1
		} });
		this.eyebrow && this.tl.to(this.eyebrow, {
			opacity: 1,
			y: 0
		}, 0);
		this.headline && this.tl.to(this.headline, {
			opacity: 1,
			y: 0
		}, SPACING);
		this.subheadline && this.tl.to(this.subheadline, {
			opacity: 1,
			y: 0
		}, SPACING);
		this.button && this.tl.to(this.button, {
			opacity: 1,
			y: 0
		}, SPACING);
	}
	disconnectedCallback() {
		this.tl?.kill();
	}
};
window.customElements.define("page-header-animation", PageHeaderAnimation);
//#endregion
